/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'profile-home': {
    width: 80,
    height: 80,
    viewBox: '0 0 80 80',
    data: `<defs><clipPath id="svgicon_profile-home_a"><path pid="0" d="M0 0h80v80H0z"/></clipPath></defs><g clip-path="url(#svgicon_profile-home_a)"><path pid="1" d="M24.5 26.018a8.25 8.25 0 01-8.253 8.25A8.25 8.25 0 018 26.018a8.25 8.25 0 018.247-8.25 8.25 8.25 0 018.253 8.25zm7.5 29.75H.5v-8.6a8.4 8.4 0 018.394-8.4H23.6a8.4 8.4 0 018.4 8.4zm13.927-27h34.078m-34.078 8h34.078m-34.078 8h34.078" _fill="none" _stroke="#000" data-name="Group 961"/></g>`
  }
})
/* tslint:enable */
